<template>
  <v-app>
    <NavBar />
    <v-main class="ma-4">
      <h1>User List</h1>
      <UserList />
    </v-main>
  </v-app>
</template>

<script>
import NavBar from "@/components/NavBar";
import UserList from "@/components/UserList";

export default {
  components: {
    NavBar,
    UserList,
  },
};
</script>

<style>
</style>